// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderSummaryStyles } from "@bg/Overrides/Widgets/OnePageCheckout/OnePageCheckoutOrderSummary";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { color } from "@bg/XDL/Utilities";
import { css } from "styled-components";

const orderSummaryItemsTypographyStyles = {
    size: 18,
    lineHeight: fontConfig.lineHeight.small,
};

const orderSummaryTotalStyles = {
    size: 18,
    lineHeight: fontConfig.lineHeight.small,
    weight: fontConfig.weight.bold,
};

orderSummaryStyles.cartTotal = {
    container: {
        gap: 12,
    },
    subtotalValue: {
        ...orderSummaryTotalStyles,
        css: css`
            margin-top: 6px;
            margin-left: auto;
        `,
    },
    subtotalLabel: {
        ...orderSummaryTotalStyles,
        css: css`
            margin-top: 6px;
        `,
    },
    titleGridItem: {
        css: css`
            padding: 12px 0;
            border-top: 2px solid ${color("common.ui3")};
            border-bottom: 2px solid ${color("common.ui3")};
        `,
    },
    totalWrapper: {
        gap: 10,
        css: css`
            margin-top: 8px;
            padding: 12px 0 20px;
            border-top: 2px solid ${color("common.ui3")};
        `,
    },
    labelGridItem: {
        width: 6,
        css: css`
            padding-left: 0px;
        `,
    },
    valueGridItem: {
        width: 6,
        css: css`
            padding-right: 0;
        `,
    },
    shippingAndHandlingLabel: {
        ...orderSummaryItemsTypographyStyles,
    },
    shippingAndHandlingValue: {
        ...orderSummaryItemsTypographyStyles,
    },
    promotionLabel: {
        ...orderSummaryItemsTypographyStyles,
    },
    promotionValue: {
        ...orderSummaryItemsTypographyStyles,
    },
    discountsLabel: {
        ...orderSummaryItemsTypographyStyles,
    },
    discountsValue: {
        ...orderSummaryItemsTypographyStyles,
    },
    otherChargesValue: {
        ...orderSummaryItemsTypographyStyles,
    },
    taxLabel: {
        ...orderSummaryItemsTypographyStyles,
    },
    taxValue: {
        ...orderSummaryItemsTypographyStyles,
    },
    totalLabel: {
        ...orderSummaryTotalStyles,
    },
    totalValue: {
        ...orderSummaryTotalStyles,
    },
};
